/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Takeoffline1Inputs */

const en_takeoffline1 = /** @type {(inputs: Takeoffline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take offline`)
};

const de_takeoffline1 = /** @type {(inputs: Takeoffline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline nehmen`)
};

/**
* | output |
* | --- |
* | "Take offline" |
*
* @param {Takeoffline1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const takeoffline1 = /** @type {((inputs?: Takeoffline1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Takeoffline1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_takeoffline1(inputs)
	return de_takeoffline1(inputs)
});
export { takeoffline1 as "takeOffline" }